import { useEffect } from "react";

// Sets <title>, meta description and an optional JSON-LD block for the current page.
export default function usePageMeta({ title, description, jsonLd }) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (!title) return undefined;
    const prevTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content");
    document.title = title;
    if (meta && description) meta.setAttribute("content", description);
    let script;
    if (ld) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = ld;
      document.head.appendChild(script);
    }
    return () => {
      document.title = prevTitle;
      if (meta && prevDesc != null) meta.setAttribute("content", prevDesc);
      if (script) script.remove();
    };
  }, [title, description, ld]);
}
